import { ArrowForward } from '@mui/icons-material';
import { GradientButton } from '@/components/styled/common.styled';
import { PLAN_SELECTION_PATH } from '@/constants/pages';
import { ANALYTICS_EVENTS, captureEvent } from '@/lib/analytics';
import Link from 'next/link';
import { type FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const LandingStickyCta: FunctionComponent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <GradientButton
      component={Link}
      href={PLAN_SELECTION_PATH}
      onClick={() =>
        captureEvent(ANALYTICS_EVENTS.SIGNUP_CTA_CLICKED, {
          location: 'sticky_cta'
        })
      }
      endIcon={<ArrowForward />}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1200,
        color: 'white',
        borderRadius: 10,
        px: 3,
        py: 1.5,
        fontWeight: 500,
        boxShadow: '0 4px 16px rgba(37, 99, 235, 0.4)',
        animation: 'slideUp 0.3s ease-out',
        '@keyframes slideUp': {
          from: { opacity: 0, transform: 'translateY(20px)' },
          to: { opacity: 1, transform: 'translateY(0)' }
        },
        '&:hover': { boxShadow: '0 6px 20px rgba(37, 99, 235, 0.5)' }
      }}
    >
      {t('landing:stickyCta.text')}
    </GradientButton>
  );
};
